import {Ldtk} from '@theatrejs/plugin-ldtk';export default new Ldtk({
	"__header__": {
		"fileType": "LDtk Project JSON",
		"app": "LDtk",
		"doc": "https://ldtk.io/json",
		"schema": "https://ldtk.io/files/JSON_SCHEMA.json",
		"appAuthor": "Sebastien 'deepnight' Benard",
		"appVersion": "1.5.3",
		"url": "https://ldtk.io"
	},
	"iid": "d211b360-9b00-11ef-8143-dd7f077a4744",
	"jsonVersion": "1.5.3",
	"appBuildId": 473703,
	"nextUid": 94,
	"identifierStyle": "Free",
	"toc": [],
	"worldLayout": "Free",
	"worldGridWidth": 256,
	"worldGridHeight": 256,
	"defaultLevelWidth": 256,
	"defaultLevelHeight": 256,
	"defaultPivotX": 0.5,
	"defaultPivotY": 0.5,
	"defaultGridSize": 32,
	"defaultEntityWidth": 32,
	"defaultEntityHeight": 32,
	"bgColor": "#40465B",
	"defaultLevelBgColor": "#696A79",
	"minifyJson": false,
	"externalLevels": false,
	"exportTiled": false,
	"simplifiedExport": false,
	"imageExportMode": "None",
	"exportLevelBg": true,
	"pngFilePattern": null,
	"backupOnSave": true,
	"backupLimit": 10,
	"backupRelPath": ".ldtk",
	"levelNamePattern": "Stage%idx1",
	"tutorialDesc": null,
	"customCommands": [],
	"flags": [],
	"defs": { "layers": [
		{
			"__type": "Entities",
			"identifier": "interactions",
			"type": "Entities",
			"uid": 65,
			"doc": null,
			"uiColor": null,
			"gridSize": 32,
			"guideGridWid": 0,
			"guideGridHei": 0,
			"displayOpacity": 1,
			"inactiveOpacity": 0.6,
			"hideInList": false,
			"hideFieldsWhenInactive": false,
			"canSelectWhenInactive": false,
			"renderInWorldView": true,
			"pxOffsetX": 0,
			"pxOffsetY": 0,
			"parallaxFactorX": 0,
			"parallaxFactorY": 0,
			"parallaxScaling": true,
			"requiredTags": ["interaction"],
			"excludedTags": [ "entity", "environment" ],
			"autoTilesKilledByOtherLayerUid": null,
			"uiFilterTags": [],
			"useAsyncRender": false,
			"intGridValues": [],
			"intGridValuesGroups": [],
			"autoRuleGroups": [],
			"autoSourceLayerDefUid": null,
			"tilesetDefUid": null,
			"tilePivotX": 0,
			"tilePivotY": 0,
			"biomeFieldUid": null
		},
		{
			"__type": "Entities",
			"identifier": "entities",
			"type": "Entities",
			"uid": 64,
			"doc": null,
			"uiColor": null,
			"gridSize": 32,
			"guideGridWid": 0,
			"guideGridHei": 0,
			"displayOpacity": 1,
			"inactiveOpacity": 0.6,
			"hideInList": false,
			"hideFieldsWhenInactive": false,
			"canSelectWhenInactive": false,
			"renderInWorldView": true,
			"pxOffsetX": 0,
			"pxOffsetY": 0,
			"parallaxFactorX": 0,
			"parallaxFactorY": 0,
			"parallaxScaling": true,
			"requiredTags": ["entity"],
			"excludedTags": [ "interaction", "environment" ],
			"autoTilesKilledByOtherLayerUid": null,
			"uiFilterTags": [],
			"useAsyncRender": false,
			"intGridValues": [],
			"intGridValuesGroups": [],
			"autoRuleGroups": [],
			"autoSourceLayerDefUid": null,
			"tilesetDefUid": null,
			"tilePivotX": 0,
			"tilePivotY": 0,
			"biomeFieldUid": null
		},
		{
			"__type": "Entities",
			"identifier": "environment",
			"type": "Entities",
			"uid": 80,
			"doc": null,
			"uiColor": null,
			"gridSize": 32,
			"guideGridWid": 0,
			"guideGridHei": 0,
			"displayOpacity": 1,
			"inactiveOpacity": 0.6,
			"hideInList": false,
			"hideFieldsWhenInactive": false,
			"canSelectWhenInactive": false,
			"renderInWorldView": true,
			"pxOffsetX": 0,
			"pxOffsetY": 0,
			"parallaxFactorX": 0,
			"parallaxFactorY": 0,
			"parallaxScaling": true,
			"requiredTags": ["environment"],
			"excludedTags": [ "entity", "interaction" ],
			"autoTilesKilledByOtherLayerUid": null,
			"uiFilterTags": [],
			"useAsyncRender": false,
			"intGridValues": [],
			"intGridValuesGroups": [],
			"autoRuleGroups": [],
			"autoSourceLayerDefUid": null,
			"tilesetDefUid": null,
			"tilePivotX": 0,
			"tilePivotY": 0,
			"biomeFieldUid": null
		}
	], "entities": [
		{
			"identifier": "BUTTON",
			"uid": 32,
			"tags": ["entity"],
			"exportToToc": false,
			"allowOutOfBounds": false,
			"doc": null,
			"width": 32,
			"height": 32,
			"resizableX": false,
			"resizableY": false,
			"minWidth": null,
			"maxWidth": null,
			"minHeight": null,
			"maxHeight": null,
			"keepAspectRatio": false,
			"tileOpacity": 1,
			"fillOpacity": 0.08,
			"lineOpacity": 0,
			"hollow": false,
			"color": "#BE4A2F",
			"renderMode": "Tile",
			"showName": true,
			"tilesetId": 52,
			"tileRenderMode": "FullSizeUncropped",
			"tileRect": { "tilesetUid": 52, "x": 400, "y": 16, "w": 16, "h": 16 },
			"uiTileRect": null,
			"nineSliceBorders": [],
			"maxCount": 0,
			"limitScope": "PerLevel",
			"limitBehavior": "MoveLastOne",
			"pivotX": 0.5,
			"pivotY": 0.5,
			"fieldDefs": []
		},
		{
			"identifier": "INTERACTION",
			"uid": 43,
			"tags": ["interaction"],
			"exportToToc": false,
			"allowOutOfBounds": true,
			"doc": null,
			"width": 32,
			"height": 32,
			"resizableX": false,
			"resizableY": false,
			"minWidth": null,
			"maxWidth": null,
			"minHeight": null,
			"maxHeight": null,
			"keepAspectRatio": false,
			"tileOpacity": 1,
			"fillOpacity": 0.08,
			"lineOpacity": 0,
			"hollow": false,
			"color": "#FEE761",
			"renderMode": "Tile",
			"showName": true,
			"tilesetId": 52,
			"tileRenderMode": "FullSizeUncropped",
			"tileRect": { "tilesetUid": 52, "x": 448, "y": 0, "w": 16, "h": 16 },
			"uiTileRect": null,
			"nineSliceBorders": [],
			"maxCount": 0,
			"limitScope": "PerLevel",
			"limitBehavior": "MoveLastOne",
			"pivotX": 0.5,
			"pivotY": 0.5,
			"fieldDefs": [
				{
					"identifier": "SOURCE",
					"doc": null,
					"__type": "EntityRef",
					"uid": 46,
					"type": "F_EntityRef",
					"isArray": false,
					"canBeNull": false,
					"arrayMinLength": null,
					"arrayMaxLength": null,
					"editorDisplayMode": "RefLinkBetweenPivots",
					"editorDisplayScale": 1,
					"editorDisplayPos": "Above",
					"editorLinkStyle": "ZigZag",
					"editorDisplayColor": null,
					"editorAlwaysShow": true,
					"editorShowInWorld": true,
					"editorCutLongValues": true,
					"editorTextSuffix": null,
					"editorTextPrefix": null,
					"useForSmartColor": false,
					"exportToToc": false,
					"searchable": false,
					"min": null,
					"max": null,
					"regex": null,
					"acceptFileTypes": null,
					"defaultOverride": null,
					"textLanguageMode": null,
					"symmetricalRef": false,
					"autoChainRef": true,
					"allowOutOfLevelRef": true,
					"allowedRefs": "Any",
					"allowedRefsEntityUid": null,
					"allowedRefTags": [],
					"tilesetUid": null
				},
				{
					"identifier": "STATE",
					"doc": null,
					"__type": "LocalEnum.STATES",
					"uid": 47,
					"type": "F_Enum(39)",
					"isArray": false,
					"canBeNull": false,
					"arrayMinLength": null,
					"arrayMaxLength": null,
					"editorDisplayMode": "Hidden",
					"editorDisplayScale": 1,
					"editorDisplayPos": "Above",
					"editorLinkStyle": "StraightArrow",
					"editorDisplayColor": null,
					"editorAlwaysShow": false,
					"editorShowInWorld": true,
					"editorCutLongValues": true,
					"editorTextSuffix": null,
					"editorTextPrefix": null,
					"useForSmartColor": false,
					"exportToToc": false,
					"searchable": false,
					"min": null,
					"max": null,
					"regex": null,
					"acceptFileTypes": null,
					"defaultOverride": null,
					"textLanguageMode": null,
					"symmetricalRef": false,
					"autoChainRef": true,
					"allowOutOfLevelRef": true,
					"allowedRefs": "OnlySame",
					"allowedRefsEntityUid": null,
					"allowedRefTags": [],
					"tilesetUid": null
				},
				{
					"identifier": "TARGET",
					"doc": null,
					"__type": "EntityRef",
					"uid": 48,
					"type": "F_EntityRef",
					"isArray": false,
					"canBeNull": false,
					"arrayMinLength": null,
					"arrayMaxLength": null,
					"editorDisplayMode": "RefLinkBetweenPivots",
					"editorDisplayScale": 1,
					"editorDisplayPos": "Above",
					"editorLinkStyle": "StraightArrow",
					"editorDisplayColor": null,
					"editorAlwaysShow": true,
					"editorShowInWorld": true,
					"editorCutLongValues": true,
					"editorTextSuffix": null,
					"editorTextPrefix": null,
					"useForSmartColor": false,
					"exportToToc": false,
					"searchable": false,
					"min": null,
					"max": null,
					"regex": null,
					"acceptFileTypes": null,
					"defaultOverride": null,
					"textLanguageMode": null,
					"symmetricalRef": false,
					"autoChainRef": true,
					"allowOutOfLevelRef": true,
					"allowedRefs": "Any",
					"allowedRefsEntityUid": null,
					"allowedRefTags": [],
					"tilesetUid": null
				},
				{
					"identifier": "ACTION",
					"doc": null,
					"__type": "LocalEnum.ACTIONS",
					"uid": 51,
					"type": "F_Enum(44)",
					"isArray": false,
					"canBeNull": false,
					"arrayMinLength": null,
					"arrayMaxLength": null,
					"editorDisplayMode": "Hidden",
					"editorDisplayScale": 1,
					"editorDisplayPos": "Above",
					"editorLinkStyle": "StraightArrow",
					"editorDisplayColor": null,
					"editorAlwaysShow": false,
					"editorShowInWorld": true,
					"editorCutLongValues": true,
					"editorTextSuffix": null,
					"editorTextPrefix": null,
					"useForSmartColor": false,
					"exportToToc": false,
					"searchable": false,
					"min": null,
					"max": null,
					"regex": null,
					"acceptFileTypes": null,
					"defaultOverride": null,
					"textLanguageMode": null,
					"symmetricalRef": false,
					"autoChainRef": true,
					"allowOutOfLevelRef": true,
					"allowedRefs": "OnlySame",
					"allowedRefsEntityUid": null,
					"allowedRefTags": [],
					"tilesetUid": null
				}
			]
		},
		{
			"identifier": "DOOR",
			"uid": 53,
			"tags": ["entity"],
			"exportToToc": false,
			"allowOutOfBounds": false,
			"doc": null,
			"width": 32,
			"height": 32,
			"resizableX": false,
			"resizableY": false,
			"minWidth": null,
			"maxWidth": null,
			"minHeight": null,
			"maxHeight": null,
			"keepAspectRatio": false,
			"tileOpacity": 1,
			"fillOpacity": 0.08,
			"lineOpacity": 0,
			"hollow": false,
			"color": "#BE4A2F",
			"renderMode": "Tile",
			"showName": true,
			"tilesetId": 52,
			"tileRenderMode": "FullSizeUncropped",
			"tileRect": { "tilesetUid": 52, "x": 272, "y": 128, "w": 16, "h": 16 },
			"uiTileRect": null,
			"nineSliceBorders": [],
			"maxCount": 0,
			"limitScope": "PerLevel",
			"limitBehavior": "MoveLastOne",
			"pivotX": 0.5,
			"pivotY": 0.5,
			"fieldDefs": []
		},
		{
			"identifier": "HERO",
			"uid": 83,
			"tags": ["entity"],
			"exportToToc": false,
			"allowOutOfBounds": true,
			"doc": null,
			"width": 32,
			"height": 32,
			"resizableX": false,
			"resizableY": false,
			"minWidth": null,
			"maxWidth": null,
			"minHeight": null,
			"maxHeight": null,
			"keepAspectRatio": false,
			"tileOpacity": 1,
			"fillOpacity": 0.08,
			"lineOpacity": 0,
			"hollow": false,
			"color": "#124E89",
			"renderMode": "Tile",
			"showName": true,
			"tilesetId": 52,
			"tileRenderMode": "FullSizeUncropped",
			"tileRect": { "tilesetUid": 52, "x": 0, "y": 240, "w": 16, "h": 16 },
			"uiTileRect": null,
			"nineSliceBorders": [],
			"maxCount": 1,
			"limitScope": "PerLevel",
			"limitBehavior": "MoveLastOne",
			"pivotX": 0.5,
			"pivotY": 0.5,
			"fieldDefs": []
		},
		{
			"identifier": "PAWN",
			"uid": 86,
			"tags": ["entity"],
			"exportToToc": false,
			"allowOutOfBounds": true,
			"doc": null,
			"width": 32,
			"height": 32,
			"resizableX": false,
			"resizableY": false,
			"minWidth": null,
			"maxWidth": null,
			"minHeight": null,
			"maxHeight": null,
			"keepAspectRatio": false,
			"tileOpacity": 1,
			"fillOpacity": 0.08,
			"lineOpacity": 0,
			"hollow": false,
			"color": "#FF0044",
			"renderMode": "Tile",
			"showName": true,
			"tilesetId": 52,
			"tileRenderMode": "FullSizeUncropped",
			"tileRect": { "tilesetUid": 52, "x": 80, "y": 272, "w": 16, "h": 16 },
			"uiTileRect": null,
			"nineSliceBorders": [],
			"maxCount": 0,
			"limitScope": "PerLevel",
			"limitBehavior": "MoveLastOne",
			"pivotX": 0.5,
			"pivotY": 0.5,
			"fieldDefs": []
		},
		{
			"identifier": "KING",
			"uid": 87,
			"tags": ["entity"],
			"exportToToc": false,
			"allowOutOfBounds": true,
			"doc": null,
			"width": 32,
			"height": 32,
			"resizableX": false,
			"resizableY": false,
			"minWidth": null,
			"maxWidth": null,
			"minHeight": null,
			"maxHeight": null,
			"keepAspectRatio": false,
			"tileOpacity": 1,
			"fillOpacity": 0.08,
			"lineOpacity": 0,
			"hollow": false,
			"color": "#FF0044",
			"renderMode": "Tile",
			"showName": true,
			"tilesetId": 52,
			"tileRenderMode": "FullSizeUncropped",
			"tileRect": { "tilesetUid": 52, "x": 80, "y": 240, "w": 16, "h": 16 },
			"uiTileRect": null,
			"nineSliceBorders": [],
			"maxCount": 1,
			"limitScope": "PerLevel",
			"limitBehavior": "MoveLastOne",
			"pivotX": 0.5,
			"pivotY": 0.5,
			"fieldDefs": []
		},
		{
			"identifier": "LOGIC_GATE_AND",
			"uid": 71,
			"tags": ["entity"],
			"exportToToc": false,
			"allowOutOfBounds": true,
			"doc": null,
			"width": 32,
			"height": 32,
			"resizableX": false,
			"resizableY": false,
			"minWidth": null,
			"maxWidth": null,
			"minHeight": null,
			"maxHeight": null,
			"keepAspectRatio": false,
			"tileOpacity": 1,
			"fillOpacity": 0.08,
			"lineOpacity": 0,
			"hollow": false,
			"color": "#63C74D",
			"renderMode": "Tile",
			"showName": true,
			"tilesetId": 52,
			"tileRenderMode": "FullSizeUncropped",
			"tileRect": { "tilesetUid": 52, "x": 400, "y": 0, "w": 16, "h": 16 },
			"uiTileRect": null,
			"nineSliceBorders": [],
			"maxCount": 0,
			"limitScope": "PerLevel",
			"limitBehavior": "MoveLastOne",
			"pivotX": 0.5,
			"pivotY": 0.5,
			"fieldDefs": []
		},
		{
			"identifier": "TIMER_1000",
			"uid": 72,
			"tags": ["entity"],
			"exportToToc": false,
			"allowOutOfBounds": true,
			"doc": null,
			"width": 32,
			"height": 32,
			"resizableX": false,
			"resizableY": false,
			"minWidth": null,
			"maxWidth": null,
			"minHeight": null,
			"maxHeight": null,
			"keepAspectRatio": false,
			"tileOpacity": 1,
			"fillOpacity": 0.08,
			"lineOpacity": 0,
			"hollow": false,
			"color": "#63C74D",
			"renderMode": "Tile",
			"showName": true,
			"tilesetId": 52,
			"tileRenderMode": "FullSizeUncropped",
			"tileRect": { "tilesetUid": 52, "x": 208, "y": 64, "w": 16, "h": 16 },
			"uiTileRect": null,
			"nineSliceBorders": [],
			"maxCount": 0,
			"limitScope": "PerLevel",
			"limitBehavior": "MoveLastOne",
			"pivotX": 0.5,
			"pivotY": 0.5,
			"fieldDefs": []
		},
		{
			"identifier": "ZONE",
			"uid": 85,
			"tags": ["entity"],
			"exportToToc": false,
			"allowOutOfBounds": true,
			"doc": null,
			"width": 32,
			"height": 32,
			"resizableX": false,
			"resizableY": false,
			"minWidth": null,
			"maxWidth": null,
			"minHeight": null,
			"maxHeight": null,
			"keepAspectRatio": false,
			"tileOpacity": 1,
			"fillOpacity": 0.08,
			"lineOpacity": 0,
			"hollow": false,
			"color": "#63C74D",
			"renderMode": "Tile",
			"showName": true,
			"tilesetId": 52,
			"tileRenderMode": "FullSizeUncropped",
			"tileRect": { "tilesetUid": 52, "x": 384, "y": 64, "w": 16, "h": 16 },
			"uiTileRect": null,
			"nineSliceBorders": [],
			"maxCount": 0,
			"limitScope": "PerLevel",
			"limitBehavior": "MoveLastOne",
			"pivotX": 0.5,
			"pivotY": 0.5,
			"fieldDefs": []
		},
		{
			"identifier": "GROUND",
			"uid": 81,
			"tags": ["environment"],
			"exportToToc": false,
			"allowOutOfBounds": true,
			"doc": null,
			"width": 32,
			"height": 32,
			"resizableX": false,
			"resizableY": false,
			"minWidth": null,
			"maxWidth": null,
			"minHeight": null,
			"maxHeight": null,
			"keepAspectRatio": false,
			"tileOpacity": 1,
			"fillOpacity": 0.08,
			"lineOpacity": 0,
			"hollow": false,
			"color": "#68386C",
			"renderMode": "Tile",
			"showName": true,
			"tilesetId": 52,
			"tileRenderMode": "NineSlice",
			"tileRect": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
			"uiTileRect": null,
			"nineSliceBorders": [2,2,2,2],
			"maxCount": 0,
			"limitScope": "PerLevel",
			"limitBehavior": "MoveLastOne",
			"pivotX": 0.5,
			"pivotY": 0.5,
			"fieldDefs": []
		}
	], "tilesets": [
		{
			"__cWid": 32,
			"__cHei": 64,
			"identifier": "Internal_Icons",
			"uid": 52,
			"relPath": null,
			"embedAtlas": "LdtkIcons",
			"pxWid": 512,
			"pxHei": 1024,
			"tileGridSize": 16,
			"spacing": 0,
			"padding": 0,
			"tags": [],
			"tagsSourceEnumUid": null,
			"enumTags": [],
			"customData": [],
			"savedSelections": [],
			"cachedPixelData": {
				"opaqueTiles": "00000000000000000000000000000000000000000000000000000000000000000000000000000000111111111000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
				"averageColors": "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"
			}
		}
	], "enums": [
		{ "identifier": "STATES", "uid": 39, "values": [
			{ "id": "STATE_ACTIVATED", "tileRect": null, "color": 2513986 },
			{ "id": "STATE_ENABLED", "tileRect": null, "color": 2513986 },
			{ "id": "STATE_ENTERED", "tileRect": null, "color": 2513986 },
			{ "id": "STATE_OPENED", "tileRect": null, "color": 2513986 },
			{ "id": "STATE_CLOSED", "tileRect": null, "color": 10626611 },
			{ "id": "STATE_DEACTIVATED", "tileRect": null, "color": 10626611 },
			{ "id": "STATE_DISABLED", "tileRect": null, "color": 10626611 },
			{ "id": "STATE_LEFT", "tileRect": null, "color": 10626611 },
			{ "id": "STATE_IDLE", "tileRect": null, "color": 1199753 },
			{ "id": "STATE_STARTED", "tileRect": null, "color": 1199753 }
		], "iconTilesetUid": null, "externalRelPath": null, "externalFileChecksum": null, "tags": [] },
		{ "identifier": "ACTIONS", "uid": 44, "values": [
			{ "id": "ACTION_ACTIVATE", "tileRect": null, "color": 2513986 },
			{ "id": "ACTION_ACTIVATE_FIRST", "tileRect": null, "color": 2513986 },
			{ "id": "ACTION_ACTIVATE_SECOND", "tileRect": null, "color": 2513986 },
			{ "id": "ACTION_ENABLE", "tileRect": null, "color": 2513986 },
			{ "id": "ACTION_OPEN", "tileRect": null, "color": 2513986 },
			{ "id": "ACTION_CLOSE", "tileRect": null, "color": 10626611 },
			{ "id": "ACTION_DEACTIVATE", "tileRect": null, "color": 10626611 },
			{ "id": "ACTION_DEACTIVATE_FIRST", "tileRect": null, "color": 10626611 },
			{ "id": "ACTION_DEACTIVATE_SECOND", "tileRect": null, "color": 10626611 },
			{ "id": "ACTION_DISABLE", "tileRect": null, "color": 10626611 },
			{ "id": "ACTION_IDLE", "tileRect": null, "color": 1199753 },
			{ "id": "ACTION_INCREASE", "tileRect": null, "color": 1199753 },
			{ "id": "ACTION_START", "tileRect": null, "color": 1199753 }
		], "iconTilesetUid": null, "externalRelPath": null, "externalFileChecksum": null, "tags": [] }
	], "externalEnums": [], "levelFields": [] },
	"levels": [
		{
			"identifier": "zero",
			"iid": "d2124fa0-9b00-11ef-8143-079f138b3d45",
			"uid": 0,
			"worldX": -288,
			"worldY": -192,
			"worldDepth": 0,
			"pxWid": 416,
			"pxHei": 320,
			"__bgColor": "#696A79",
			"bgColor": null,
			"useAutoIdentifier": false,
			"bgRelPath": null,
			"bgPos": null,
			"bgPivotX": 0.5,
			"bgPivotY": 0.5,
			"__smartColor": "#ADADB5",
			"__bgPos": null,
			"externalRelPath": null,
			"fieldInstances": [],
			"layerInstances": [
				{
					"__identifier": "interactions",
					"__type": "Entities",
					"__cWid": 13,
					"__cHei": 10,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "08248140-c210-11ef-9226-b133c7298801",
					"levelId": 0,
					"layerDefUid": 65,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 7174765,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": []
				},
				{
					"__identifier": "entities",
					"__type": "Entities",
					"__cWid": 13,
					"__cHei": 10,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "a657c290-c210-11ef-9226-c5e7882cf861",
					"levelId": 0,
					"layerDefUid": 64,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 7422727,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "HERO",
							"__grid": [6,3],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 0, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#124E89",
							"iid": "4e94d6d0-fa90-11f0-b201-af27adaf8051",
							"width": 32,
							"height": 32,
							"defUid": 83,
							"px": [208,112],
							"fieldInstances": [],
							"__worldX": -80,
							"__worldY": -80
						},
						{
							"__identifier": "KING",
							"__grid": [6,0],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 80, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#FF0044",
							"iid": "afa715c0-21a0-11f1-91eb-db44aeb23909",
							"width": 32,
							"height": 32,
							"defUid": 87,
							"px": [208,16],
							"fieldInstances": [],
							"__worldX": -80,
							"__worldY": -176
						},
						{
							"__identifier": "PAWN",
							"__grid": [6,5],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 80, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#FF0044",
							"iid": "39115310-21a0-11f1-b642-bbe03083ad8e",
							"width": 32,
							"height": 32,
							"defUid": 86,
							"px": [208,176],
							"fieldInstances": [],
							"__worldX": -80,
							"__worldY": -16
						}
					]
				},
				{
					"__identifier": "environment",
					"__type": "Entities",
					"__cWid": 13,
					"__cHei": 10,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "2230d2c0-fa90-11f0-a3c6-7100dd908c88",
					"levelId": 0,
					"layerDefUid": 80,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 3523423,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "GROUND",
							"__grid": [8,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "e336d6e0-fa90-11f0-ab35-b7ebaefa09a0",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,176],
							"fieldInstances": [],
							"__worldX": -16,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "e461e960-fa90-11f0-ab35-87145e2a0ca1",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,176],
							"fieldInstances": [],
							"__worldX": -48,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "e4a497b0-fa90-11f0-ab35-9f4f2ecb74d1",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,208],
							"fieldInstances": [],
							"__worldX": -48,
							"__worldY": 16
						},
						{
							"__identifier": "GROUND",
							"__grid": [8,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "e4cf5130-fa90-11f0-ab35-091067239780",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,208],
							"fieldInstances": [],
							"__worldX": -16,
							"__worldY": 16
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "73241940-fa90-11f0-9890-612ea3f38f63",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,208],
							"fieldInstances": [],
							"__worldX": -80,
							"__worldY": 16
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,7],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "7361be80-fa90-11f0-9890-031ea7487edc",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,240],
							"fieldInstances": [],
							"__worldX": -48,
							"__worldY": 48
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "82aa6720-fa90-11f0-9890-4dedcecfe536",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,208],
							"fieldInstances": [],
							"__worldX": -144,
							"__worldY": 16
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,7],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "89d7b6b0-fa90-11f0-9890-2fe2cba0b9ac",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,240],
							"fieldInstances": [],
							"__worldX": -144,
							"__worldY": 48
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "8fe08230-fa90-11f0-b201-ff33d1654dda",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,176],
							"fieldInstances": [],
							"__worldX": -144,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,7],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "3dd26100-fa90-11f0-a81c-cba069d61d67",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,240],
							"fieldInstances": [],
							"__worldX": -80,
							"__worldY": 48
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "8ff48e20-21a0-11f1-855c-e1e2ba2fb703",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,112],
							"fieldInstances": [],
							"__worldX": -144,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "929aa7e0-21a0-11f1-855c-a5a88cd219eb",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,112],
							"fieldInstances": [],
							"__worldX": -112,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "9393fc00-21a0-11f1-855c-99ee43745000",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,144],
							"fieldInstances": [],
							"__worldX": -144,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "93d74690-21a0-11f1-855c-7d6bde503a26",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,144],
							"fieldInstances": [],
							"__worldX": -112,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "9422f590-21a0-11f1-855c-b7f641a9ec0c",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,112],
							"fieldInstances": [],
							"__worldX": -80,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "946f19c0-21a0-11f1-855c-d9106900ff8c",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,144],
							"fieldInstances": [],
							"__worldX": -80,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "94ff72e0-21a0-11f1-855c-89ad83caa204",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,112],
							"fieldInstances": [],
							"__worldX": -48,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "954ecb60-21a0-11f1-855c-b72776285bd1",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,144],
							"fieldInstances": [],
							"__worldX": -48,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "95a21b80-21a0-11f1-855c-ef2cdfb86ba2",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,176],
							"fieldInstances": [],
							"__worldX": -112,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "95e95db0-21a0-11f1-855c-4f81bbe25235",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,208],
							"fieldInstances": [],
							"__worldX": -112,
							"__worldY": 16
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,7],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "96347070-21a0-11f1-855c-c50c40b54ba4",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,240],
							"fieldInstances": [],
							"__worldX": -112,
							"__worldY": 48
						},
						{
							"__identifier": "GROUND",
							"__grid": [8,7],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a0005fb0-21a0-11f1-855c-414d1d74da28",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,240],
							"fieldInstances": [],
							"__worldX": -16,
							"__worldY": 48
						},
						{
							"__identifier": "GROUND",
							"__grid": [8,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a4274d10-21a0-11f1-855c-5f721008f749",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,112],
							"fieldInstances": [],
							"__worldX": -16,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [8,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a4725fd0-21a0-11f1-855c-ffd950602583",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,144],
							"fieldInstances": [],
							"__worldX": -16,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "c700cf50-21a0-11f1-855c-43d437cd98d3",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,176],
							"fieldInstances": [],
							"__worldX": -80,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [3,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "914deb80-21a0-11f1-91eb-8377d270ffcf",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [112,16],
							"fieldInstances": [],
							"__worldX": -176,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "91938000-21a0-11f1-91eb-b7f1d92e7209",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,16],
							"fieldInstances": [],
							"__worldX": -144,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "91dfcb40-21a0-11f1-91eb-2fc68ab29a61",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,16],
							"fieldInstances": [],
							"__worldX": -112,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "922f23c0-21a0-11f1-91eb-798079ba81e2",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,16],
							"fieldInstances": [],
							"__worldX": -80,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "9270c0a0-21a0-11f1-91eb-892db9059567",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,16],
							"fieldInstances": [],
							"__worldX": -48,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [8,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "92bce4d0-21a0-11f1-91eb-758243678d60",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,16],
							"fieldInstances": [],
							"__worldX": -16,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [9,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "930efc70-21a0-11f1-91eb-938d636b0f9d",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [304,16],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [2,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "2084d3d0-21a0-11f1-8ddd-0577788d2bd4",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [80,16],
							"fieldInstances": [],
							"__worldX": -208,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [10,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "21183a30-21a0-11f1-8ddd-1154435ab9a8",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [336,16],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [3,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "597c4650-21a0-11f1-b642-27be93cb65e3",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [112,144],
							"fieldInstances": [],
							"__worldX": -176,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [3,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "59d62620-21a0-11f1-b642-f11d7fd422b9",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [112,176],
							"fieldInstances": [],
							"__worldX": -176,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [3,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "5a2b9920-21a0-11f1-b642-b7c4091e9733",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [112,208],
							"fieldInstances": [],
							"__worldX": -176,
							"__worldY": 16
						},
						{
							"__identifier": "GROUND",
							"__grid": [9,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "5acf5330-21a0-11f1-b642-ddb3eae555c9",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [304,208],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": 16
						},
						{
							"__identifier": "GROUND",
							"__grid": [9,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "5b632ec0-21a0-11f1-b642-11fc49b9f75f",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [304,176],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [9,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "5bb1c3f0-21a0-11f1-b642-2308c4152f96",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [304,144],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -48
						}
					]
				}
			],
			"__neighbours": [{ "levelIid": "ee6b5eb0-21a0-11f1-8c25-bb75fa9ded3a", "dir": "e" }]
		},
		{
			"identifier": "first",
			"iid": "ee6b5eb0-21a0-11f1-8c25-bb75fa9ded3a",
			"uid": 88,
			"worldX": 128,
			"worldY": -192,
			"worldDepth": 0,
			"pxWid": 416,
			"pxHei": 320,
			"__bgColor": "#696A79",
			"bgColor": null,
			"useAutoIdentifier": false,
			"bgRelPath": null,
			"bgPos": null,
			"bgPivotX": 0.5,
			"bgPivotY": 0.5,
			"__smartColor": "#ADADB5",
			"__bgPos": null,
			"externalRelPath": null,
			"fieldInstances": [],
			"layerInstances": [
				{
					"__identifier": "interactions",
					"__type": "Entities",
					"__cWid": 13,
					"__cHei": 10,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "ee6b5eb1-21a0-11f1-8c25-0fde8d4dc9e2",
					"levelId": 88,
					"layerDefUid": 65,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 7174765,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": []
				},
				{
					"__identifier": "entities",
					"__type": "Entities",
					"__cWid": 13,
					"__cHei": 10,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "ee6b5eb2-21a0-11f1-8c25-415ee8228961",
					"levelId": 88,
					"layerDefUid": 64,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 7422727,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "ZONE",
							"__grid": [15,6],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 384, "y": 64, "w": 16, "h": 16 },
							"__smartColor": "#63C74D",
							"iid": "ee6b85c0-21a0-11f1-8c25-e3073c41c770",
							"width": 32,
							"height": 32,
							"defUid": 85,
							"px": [496,208],
							"fieldInstances": [],
							"__worldX": 624,
							"__worldY": 16
						},
						{
							"__identifier": "ZONE",
							"__grid": [15,5],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 384, "y": 64, "w": 16, "h": 16 },
							"__smartColor": "#63C74D",
							"iid": "ee6b85c1-21a0-11f1-8c25-673d8d2bc394",
							"width": 32,
							"height": 32,
							"defUid": 85,
							"px": [496,176],
							"fieldInstances": [],
							"__worldX": 624,
							"__worldY": -16
						},
						{
							"__identifier": "HERO",
							"__grid": [6,4],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 0, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#124E89",
							"iid": "ee6b85c2-21a0-11f1-8c25-35036b8c3af9",
							"width": 32,
							"height": 32,
							"defUid": 83,
							"px": [208,144],
							"fieldInstances": [],
							"__worldX": 336,
							"__worldY": -48
						},
						{
							"__identifier": "KING",
							"__grid": [6,0],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 80, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#FF0044",
							"iid": "ee6bacd2-21a0-11f1-8c25-43be3fb5a05b",
							"width": 32,
							"height": 32,
							"defUid": 87,
							"px": [208,16],
							"fieldInstances": [],
							"__worldX": 336,
							"__worldY": -176
						},
						{
							"__identifier": "PAWN",
							"__grid": [5,5],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 80, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#FF0044",
							"iid": "181190f0-21a0-11f1-9f6b-23d525240fba",
							"width": 32,
							"height": 32,
							"defUid": 86,
							"px": [176,176],
							"fieldInstances": [],
							"__worldX": 304,
							"__worldY": -16
						},
						{
							"__identifier": "PAWN",
							"__grid": [7,5],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 80, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#FF0044",
							"iid": "191a7570-21a0-11f1-9f6b-798958784d43",
							"width": 32,
							"height": 32,
							"defUid": 86,
							"px": [240,176],
							"fieldInstances": [],
							"__worldX": 368,
							"__worldY": -16
						}
					]
				},
				{
					"__identifier": "environment",
					"__type": "Entities",
					"__cWid": 13,
					"__cHei": 10,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "ee6bacd3-21a0-11f1-8c25-b938c043a3a0",
					"levelId": 88,
					"layerDefUid": 80,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 3523423,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "GROUND",
							"__grid": [8,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6bacd4-21a0-11f1-8c25-b39b293d8d74",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,176],
							"fieldInstances": [],
							"__worldX": 400,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6bd3e0-21a0-11f1-8c25-e393ab35fdbf",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,176],
							"fieldInstances": [],
							"__worldX": 368,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6bd3e1-21a0-11f1-8c25-8574c64d890c",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,208],
							"fieldInstances": [],
							"__worldX": 368,
							"__worldY": 16
						},
						{
							"__identifier": "GROUND",
							"__grid": [8,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6bd3e2-21a0-11f1-8c25-976b0c6de639",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,208],
							"fieldInstances": [],
							"__worldX": 400,
							"__worldY": 16
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6bfaf0-21a0-11f1-8c25-a350f29d0a18",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,208],
							"fieldInstances": [],
							"__worldX": 336,
							"__worldY": 16
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,7],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6c2200-21a0-11f1-8c25-45be64d35a22",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,240],
							"fieldInstances": [],
							"__worldX": 368,
							"__worldY": 48
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6c2201-21a0-11f1-8c25-894fb8f2e02d",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,208],
							"fieldInstances": [],
							"__worldX": 272,
							"__worldY": 16
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,7],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6c4910-21a0-11f1-8c25-77587211cd46",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,240],
							"fieldInstances": [],
							"__worldX": 272,
							"__worldY": 48
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6c4914-21a0-11f1-8c25-ef33bd344089",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,176],
							"fieldInstances": [],
							"__worldX": 272,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,7],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6c7021-21a0-11f1-8c25-8b879b0f2c4c",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,240],
							"fieldInstances": [],
							"__worldX": 336,
							"__worldY": 48
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6c7023-21a0-11f1-8c25-ab9459ffba93",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,112],
							"fieldInstances": [],
							"__worldX": 272,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6c7024-21a0-11f1-8c25-3d499de8f8de",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,112],
							"fieldInstances": [],
							"__worldX": 304,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6c9730-21a0-11f1-8c25-818ea30764f1",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,144],
							"fieldInstances": [],
							"__worldX": 272,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6c9731-21a0-11f1-8c25-1970a4369a5b",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,144],
							"fieldInstances": [],
							"__worldX": 304,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6c9732-21a0-11f1-8c25-f7f91667365f",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,112],
							"fieldInstances": [],
							"__worldX": 336,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6c9733-21a0-11f1-8c25-45a7f754a59f",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,144],
							"fieldInstances": [],
							"__worldX": 336,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6c9734-21a0-11f1-8c25-53a522bb8836",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,112],
							"fieldInstances": [],
							"__worldX": 368,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6c9735-21a0-11f1-8c25-b38d788abf45",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,144],
							"fieldInstances": [],
							"__worldX": 368,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6c9736-21a0-11f1-8c25-0de1d26057bf",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,176],
							"fieldInstances": [],
							"__worldX": 304,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6c9737-21a0-11f1-8c25-9fcc119aa4c1",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,208],
							"fieldInstances": [],
							"__worldX": 304,
							"__worldY": 16
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,7],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6c9738-21a0-11f1-8c25-8f411d24224a",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,240],
							"fieldInstances": [],
							"__worldX": 304,
							"__worldY": 48
						},
						{
							"__identifier": "GROUND",
							"__grid": [8,7],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6c9739-21a0-11f1-8c25-cb7a66c3f570",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,240],
							"fieldInstances": [],
							"__worldX": 400,
							"__worldY": 48
						},
						{
							"__identifier": "GROUND",
							"__grid": [8,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6c973a-21a0-11f1-8c25-9f5c50b010c3",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,112],
							"fieldInstances": [],
							"__worldX": 400,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [8,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6c973b-21a0-11f1-8c25-3ff1ea6e7b42",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,144],
							"fieldInstances": [],
							"__worldX": 400,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6cbe40-21a0-11f1-8c25-156ccf46f90c",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,176],
							"fieldInstances": [],
							"__worldX": 336,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [3,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6cbe41-21a0-11f1-8c25-f760a388137b",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [112,16],
							"fieldInstances": [],
							"__worldX": 240,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6cbe42-21a0-11f1-8c25-f199605f037a",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,16],
							"fieldInstances": [],
							"__worldX": 272,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6cbe43-21a0-11f1-8c25-c182c985b5ef",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,16],
							"fieldInstances": [],
							"__worldX": 304,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6ce550-21a0-11f1-8c25-09e1c17acd7c",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,16],
							"fieldInstances": [],
							"__worldX": 336,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6ce551-21a0-11f1-8c25-9d6435efef06",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,16],
							"fieldInstances": [],
							"__worldX": 368,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [8,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6ce552-21a0-11f1-8c25-91341e2ba7ec",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,16],
							"fieldInstances": [],
							"__worldX": 400,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [9,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6d0c60-21a0-11f1-8c25-4f59a284f132",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [304,16],
							"fieldInstances": [],
							"__worldX": 432,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [10,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ee6d5a80-21a0-11f1-8c25-bdee0fafc76b",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [336,16],
							"fieldInstances": [],
							"__worldX": 464,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [2,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "0f277f30-21a0-11f1-8c25-552ff757b5f1",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [80,16],
							"fieldInstances": [],
							"__worldX": 208,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [3,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "63762400-21a0-11f1-9f6b-d904004f44c7",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [112,112],
							"fieldInstances": [],
							"__worldX": 240,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [9,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "646f7820-21a0-11f1-9f6b-27251ccd7d4f",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [304,112],
							"fieldInstances": [],
							"__worldX": 432,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [3,7],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "65e0e270-21a0-11f1-9f6b-4372ae551c9b",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [112,240],
							"fieldInstances": [],
							"__worldX": 240,
							"__worldY": 48
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,8],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "69cf5ab0-21a0-11f1-9f6b-416a46ebac2c",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,272],
							"fieldInstances": [],
							"__worldX": 336,
							"__worldY": 80
						},
						{
							"__identifier": "GROUND",
							"__grid": [9,7],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "6ae49b40-21a0-11f1-9f6b-2512756a246f",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [304,240],
							"fieldInstances": [],
							"__worldX": 432,
							"__worldY": 48
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,8],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "6cb0a8b0-21a0-11f1-9f6b-efb9a6c39110",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,272],
							"fieldInstances": [],
							"__worldX": 272,
							"__worldY": 80
						},
						{
							"__identifier": "GROUND",
							"__grid": [8,8],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "6d197ca0-21a0-11f1-9f6b-53854e60cbb3",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,272],
							"fieldInstances": [],
							"__worldX": 400,
							"__worldY": 80
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,8],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b969c5b0-21a0-11f1-9f6b-33c9ccca5efe",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,272],
							"fieldInstances": [],
							"__worldX": 304,
							"__worldY": 80
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,8],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b9e07c50-21a0-11f1-9f6b-d1bb2eacb490",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,272],
							"fieldInstances": [],
							"__worldX": 368,
							"__worldY": 80
						},
						{
							"__identifier": "GROUND",
							"__grid": [3,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "ba8dac40-21a0-11f1-9f6b-a7fe8d3dde10",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [112,144],
							"fieldInstances": [],
							"__worldX": 240,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [9,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "bb026710-21a0-11f1-9f6b-f131a147b0de",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [304,144],
							"fieldInstances": [],
							"__worldX": 432,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [1,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "84c5aa40-21a0-11f1-b642-3b18ec9b60f0",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [48,16],
							"fieldInstances": [],
							"__worldX": 176,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [11,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "85578a00-21a0-11f1-b642-21e06ec6b8d4",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [368,16],
							"fieldInstances": [],
							"__worldX": 496,
							"__worldY": -176
						}
					]
				}
			],
			"__neighbours": [ { "levelIid": "d2124fa0-9b00-11ef-8143-079f138b3d45", "dir": "w" }, { "levelIid": "a2ecc800-21a0-11f1-b642-4f1e5c2eace0", "dir": "e" } ]
		},
		{
			"identifier": "third",
			"iid": "a2ecc800-21a0-11f1-b642-4f1e5c2eace0",
			"uid": 89,
			"worldX": 544,
			"worldY": -192,
			"worldDepth": 0,
			"pxWid": 416,
			"pxHei": 320,
			"__bgColor": "#696A79",
			"bgColor": null,
			"useAutoIdentifier": false,
			"bgRelPath": null,
			"bgPos": null,
			"bgPivotX": 0.5,
			"bgPivotY": 0.5,
			"__smartColor": "#ADADB5",
			"__bgPos": null,
			"externalRelPath": null,
			"fieldInstances": [],
			"layerInstances": [
				{
					"__identifier": "interactions",
					"__type": "Entities",
					"__cWid": 13,
					"__cHei": 10,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "a2ecef10-21a0-11f1-b642-45af24236990",
					"levelId": 89,
					"layerDefUid": 65,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 7174765,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": []
				},
				{
					"__identifier": "entities",
					"__type": "Entities",
					"__cWid": 13,
					"__cHei": 10,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "a2ecef11-21a0-11f1-b642-39db0af0bd7a",
					"levelId": 89,
					"layerDefUid": 64,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 7422727,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "ZONE",
							"__grid": [15,6],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 384, "y": 64, "w": 16, "h": 16 },
							"__smartColor": "#63C74D",
							"iid": "a2ecef12-21a0-11f1-b642-e3e9b608df77",
							"width": 32,
							"height": 32,
							"defUid": 85,
							"px": [496,208],
							"fieldInstances": [],
							"__worldX": 1040,
							"__worldY": 16
						},
						{
							"__identifier": "ZONE",
							"__grid": [15,5],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 384, "y": 64, "w": 16, "h": 16 },
							"__smartColor": "#63C74D",
							"iid": "a2ecef13-21a0-11f1-b642-b1277101608a",
							"width": 32,
							"height": 32,
							"defUid": 85,
							"px": [496,176],
							"fieldInstances": [],
							"__worldX": 1040,
							"__worldY": -16
						},
						{
							"__identifier": "HERO",
							"__grid": [6,4],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 0, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#124E89",
							"iid": "a2ed1620-21a0-11f1-b642-cd1be39f7aec",
							"width": 32,
							"height": 32,
							"defUid": 83,
							"px": [208,144],
							"fieldInstances": [],
							"__worldX": 752,
							"__worldY": -48
						},
						{
							"__identifier": "KING",
							"__grid": [6,0],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 80, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#FF0044",
							"iid": "a2ed1621-21a0-11f1-b642-a9ab583ea267",
							"width": 32,
							"height": 32,
							"defUid": 87,
							"px": [208,16],
							"fieldInstances": [],
							"__worldX": 752,
							"__worldY": -176
						},
						{
							"__identifier": "PAWN",
							"__grid": [4,5],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 80, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#FF0044",
							"iid": "a2ed1622-21a0-11f1-b642-a5ecbc590d23",
							"width": 32,
							"height": 32,
							"defUid": 86,
							"px": [144,176],
							"fieldInstances": [],
							"__worldX": 688,
							"__worldY": -16
						},
						{
							"__identifier": "PAWN",
							"__grid": [8,5],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 80, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#FF0044",
							"iid": "a2ed1623-21a0-11f1-b642-5f6487b568c2",
							"width": 32,
							"height": 32,
							"defUid": 86,
							"px": [272,176],
							"fieldInstances": [],
							"__worldX": 816,
							"__worldY": -16
						},
						{
							"__identifier": "PAWN",
							"__grid": [3,3],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 80, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#FF0044",
							"iid": "c1e7b080-21a0-11f1-b642-f17b23823137",
							"width": 32,
							"height": 32,
							"defUid": 86,
							"px": [112,112],
							"fieldInstances": [],
							"__worldX": 656,
							"__worldY": -80
						},
						{
							"__identifier": "PAWN",
							"__grid": [9,3],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 80, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#FF0044",
							"iid": "c28e77d0-21a0-11f1-b642-571a9eec6117",
							"width": 32,
							"height": 32,
							"defUid": 86,
							"px": [304,112],
							"fieldInstances": [],
							"__worldX": 848,
							"__worldY": -80
						}
					]
				},
				{
					"__identifier": "environment",
					"__type": "Entities",
					"__cWid": 13,
					"__cHei": 10,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "a2ed8b50-21a0-11f1-b642-01b29dd5f205",
					"levelId": 89,
					"layerDefUid": 80,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 3523423,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "GROUND",
							"__grid": [8,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2ed8b51-21a0-11f1-b642-a98bac965232",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,176],
							"fieldInstances": [],
							"__worldX": 816,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2ed8b52-21a0-11f1-b642-019b5740eff5",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,176],
							"fieldInstances": [],
							"__worldX": 784,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2ed8b53-21a0-11f1-b642-a1a218247511",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,208],
							"fieldInstances": [],
							"__worldX": 784,
							"__worldY": 16
						},
						{
							"__identifier": "GROUND",
							"__grid": [8,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2ed8b54-21a0-11f1-b642-77225db1ddcd",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,208],
							"fieldInstances": [],
							"__worldX": 816,
							"__worldY": 16
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2edb260-21a0-11f1-b642-35a9e821433d",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,208],
							"fieldInstances": [],
							"__worldX": 752,
							"__worldY": 16
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2edb262-21a0-11f1-b642-ebac85b3c405",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,208],
							"fieldInstances": [],
							"__worldX": 688,
							"__worldY": 16
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2edb264-21a0-11f1-b642-d32a34a157ce",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,176],
							"fieldInstances": [],
							"__worldX": 688,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2edb266-21a0-11f1-b642-497286655feb",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,112],
							"fieldInstances": [],
							"__worldX": 688,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2edb267-21a0-11f1-b642-bbccf6b30fe9",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,112],
							"fieldInstances": [],
							"__worldX": 720,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2edb268-21a0-11f1-b642-c50bdab00c0f",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,144],
							"fieldInstances": [],
							"__worldX": 688,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2edb269-21a0-11f1-b642-a18384b3b8cb",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,144],
							"fieldInstances": [],
							"__worldX": 720,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2edb26a-21a0-11f1-b642-4f4f6a23475c",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,112],
							"fieldInstances": [],
							"__worldX": 752,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2edb26b-21a0-11f1-b642-e396860d5aa2",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,144],
							"fieldInstances": [],
							"__worldX": 752,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2edd970-21a0-11f1-b642-f5a4e6e1353d",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,112],
							"fieldInstances": [],
							"__worldX": 784,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2ee0080-21a0-11f1-b642-0d31a761029d",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,144],
							"fieldInstances": [],
							"__worldX": 784,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2ee0081-21a0-11f1-b642-e51ac6e43ece",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,176],
							"fieldInstances": [],
							"__worldX": 720,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2ee0082-21a0-11f1-b642-0b60af1d4d2f",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,208],
							"fieldInstances": [],
							"__worldX": 720,
							"__worldY": 16
						},
						{
							"__identifier": "GROUND",
							"__grid": [8,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2ee2790-21a0-11f1-b642-ff778afb5697",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,112],
							"fieldInstances": [],
							"__worldX": 816,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [8,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2ee2791-21a0-11f1-b642-fb109a653de8",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,144],
							"fieldInstances": [],
							"__worldX": 816,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2ee2792-21a0-11f1-b642-29f4944da55b",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,176],
							"fieldInstances": [],
							"__worldX": 752,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [3,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2ee2793-21a0-11f1-b642-eb78bc192c31",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [112,16],
							"fieldInstances": [],
							"__worldX": 656,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2ee2794-21a0-11f1-b642-1b84a71d337f",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,16],
							"fieldInstances": [],
							"__worldX": 688,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2ee4ea0-21a0-11f1-b642-bbac8178ade7",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,16],
							"fieldInstances": [],
							"__worldX": 720,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2ee4ea1-21a0-11f1-b642-6b7595632bad",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,16],
							"fieldInstances": [],
							"__worldX": 752,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2ee4ea2-21a0-11f1-b642-f9fa9664c7d7",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,16],
							"fieldInstances": [],
							"__worldX": 784,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [8,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2ee4ea3-21a0-11f1-b642-5fe2ce52ab47",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,16],
							"fieldInstances": [],
							"__worldX": 816,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [9,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2ee4ea4-21a0-11f1-b642-892d6441f053",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [304,16],
							"fieldInstances": [],
							"__worldX": 848,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [10,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2ee4ea5-21a0-11f1-b642-a10709fdc470",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [336,16],
							"fieldInstances": [],
							"__worldX": 880,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [2,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2ee4ea6-21a0-11f1-b642-0fa8185c2514",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [80,16],
							"fieldInstances": [],
							"__worldX": 624,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [3,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2ee4ea7-21a0-11f1-b642-b5c581a9353b",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [112,112],
							"fieldInstances": [],
							"__worldX": 656,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [9,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2ee75b0-21a0-11f1-b642-5b5b40bf0f6c",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [304,112],
							"fieldInstances": [],
							"__worldX": 848,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [3,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2eec3d0-21a0-11f1-b642-4120ef4d1f22",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [112,144],
							"fieldInstances": [],
							"__worldX": 656,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [9,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2eec3d1-21a0-11f1-b642-67d465439c80",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [304,144],
							"fieldInstances": [],
							"__worldX": 848,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [1,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2eec3d2-21a0-11f1-b642-cd26424ec06c",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [48,16],
							"fieldInstances": [],
							"__worldX": 592,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [11,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2eec3d3-21a0-11f1-b642-63c84e1f6d76",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [368,16],
							"fieldInstances": [],
							"__worldX": 912,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [3,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "aeba53a0-21a0-11f1-b642-1b00ed595ecd",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [112,176],
							"fieldInstances": [],
							"__worldX": 656,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [3,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "af33f070-21a0-11f1-b642-0def6778d5a4",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [112,208],
							"fieldInstances": [],
							"__worldX": 656,
							"__worldY": 16
						},
						{
							"__identifier": "GROUND",
							"__grid": [9,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "afb92600-21a0-11f1-b642-6584e48882b4",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [304,176],
							"fieldInstances": [],
							"__worldX": 848,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [9,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b00968e0-21a0-11f1-b642-0983f82b8c8d",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [304,208],
							"fieldInstances": [],
							"__worldX": 848,
							"__worldY": 16
						},
						{
							"__identifier": "GROUND",
							"__grid": [2,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b5ff9800-21a0-11f1-b642-4937390536a6",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [80,144],
							"fieldInstances": [],
							"__worldX": 624,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [2,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b65e80e0-21a0-11f1-b642-89921947c7d3",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [80,176],
							"fieldInstances": [],
							"__worldX": 624,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [0,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b7c58af0-21a0-11f1-b642-4d9ae7931f56",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [16,16],
							"fieldInstances": [],
							"__worldX": 560,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [12,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b85520c0-21a0-11f1-b642-8965e2beb474",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [400,16],
							"fieldInstances": [],
							"__worldX": 944,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [10,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b9b88150-21a0-11f1-b642-c55f04d26b62",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [336,144],
							"fieldInstances": [],
							"__worldX": 880,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [10,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "bc6021b0-21a0-11f1-b642-27e8fae06077",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [336,176],
							"fieldInstances": [],
							"__worldX": 880,
							"__worldY": -16
						}
					]
				}
			],
			"__neighbours": [ { "levelIid": "ee6b5eb0-21a0-11f1-8c25-bb75fa9ded3a", "dir": "w" }, { "levelIid": "163c9650-21a0-11f1-b642-65b65ce4be81", "dir": "e" } ]
		},
		{
			"identifier": "fourth",
			"iid": "163c9650-21a0-11f1-b642-65b65ce4be81",
			"uid": 90,
			"worldX": 960,
			"worldY": -192,
			"worldDepth": 0,
			"pxWid": 416,
			"pxHei": 320,
			"__bgColor": "#696A79",
			"bgColor": null,
			"useAutoIdentifier": false,
			"bgRelPath": null,
			"bgPos": null,
			"bgPivotX": 0.5,
			"bgPivotY": 0.5,
			"__smartColor": "#ADADB5",
			"__bgPos": null,
			"externalRelPath": null,
			"fieldInstances": [],
			"layerInstances": [
				{
					"__identifier": "interactions",
					"__type": "Entities",
					"__cWid": 13,
					"__cHei": 10,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "163c9651-21a0-11f1-b642-c9cad5498cb2",
					"levelId": 90,
					"layerDefUid": 65,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 7174765,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": []
				},
				{
					"__identifier": "entities",
					"__type": "Entities",
					"__cWid": 13,
					"__cHei": 10,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "163c9652-21a0-11f1-b642-b3d555fe0606",
					"levelId": 90,
					"layerDefUid": 64,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 7422727,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "ZONE",
							"__grid": [15,6],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 384, "y": 64, "w": 16, "h": 16 },
							"__smartColor": "#63C74D",
							"iid": "163c9653-21a0-11f1-b642-77150ef73bc3",
							"width": 32,
							"height": 32,
							"defUid": 85,
							"px": [496,208],
							"fieldInstances": [],
							"__worldX": 1456,
							"__worldY": 16
						},
						{
							"__identifier": "ZONE",
							"__grid": [15,5],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 384, "y": 64, "w": 16, "h": 16 },
							"__smartColor": "#63C74D",
							"iid": "163c9654-21a0-11f1-b642-d7cefe315e03",
							"width": 32,
							"height": 32,
							"defUid": 85,
							"px": [496,176],
							"fieldInstances": [],
							"__worldX": 1456,
							"__worldY": -16
						},
						{
							"__identifier": "HERO",
							"__grid": [6,4],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 0, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#124E89",
							"iid": "163c9655-21a0-11f1-b642-518fb025e54d",
							"width": 32,
							"height": 32,
							"defUid": 83,
							"px": [208,144],
							"fieldInstances": [],
							"__worldX": 1168,
							"__worldY": -48
						},
						{
							"__identifier": "KING",
							"__grid": [6,0],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 80, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#FF0044",
							"iid": "163c9656-21a0-11f1-b642-b791b5d76006",
							"width": 32,
							"height": 32,
							"defUid": 87,
							"px": [208,16],
							"fieldInstances": [],
							"__worldX": 1168,
							"__worldY": -176
						},
						{
							"__identifier": "PAWN",
							"__grid": [5,5],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 80, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#FF0044",
							"iid": "163c9659-21a0-11f1-b642-777f9e5ae4bc",
							"width": 32,
							"height": 32,
							"defUid": 86,
							"px": [176,176],
							"fieldInstances": [],
							"__worldX": 1136,
							"__worldY": -16
						},
						{
							"__identifier": "PAWN",
							"__grid": [7,5],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 80, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#FF0044",
							"iid": "35b4c520-21a0-11f1-b642-e72d8896b7b3",
							"width": 32,
							"height": 32,
							"defUid": 86,
							"px": [240,176],
							"fieldInstances": [],
							"__worldX": 1200,
							"__worldY": -16
						}
					]
				},
				{
					"__identifier": "environment",
					"__type": "Entities",
					"__cWid": 13,
					"__cHei": 10,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "163cbd60-21a0-11f1-b642-ef539d188bd0",
					"levelId": 90,
					"layerDefUid": 80,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 3523423,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "GROUND",
							"__grid": [8,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163cbd61-21a0-11f1-b642-2d9c7f00c8d7",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,176],
							"fieldInstances": [],
							"__worldX": 1232,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163cbd62-21a0-11f1-b642-8dfb737654b3",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,176],
							"fieldInstances": [],
							"__worldX": 1200,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163cbd63-21a0-11f1-b642-a1a8cded3990",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,208],
							"fieldInstances": [],
							"__worldX": 1200,
							"__worldY": 16
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163ce470-21a0-11f1-b642-47af8ef4a3c0",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,208],
							"fieldInstances": [],
							"__worldX": 1168,
							"__worldY": 16
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163ce472-21a0-11f1-b642-4161567a64de",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,176],
							"fieldInstances": [],
							"__worldX": 1104,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163ce474-21a0-11f1-b642-a141788949e2",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,112],
							"fieldInstances": [],
							"__worldX": 1136,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163ce475-21a0-11f1-b642-8b16983f6f5f",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,144],
							"fieldInstances": [],
							"__worldX": 1104,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163ce476-21a0-11f1-b642-9d1ad9a7dbca",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,144],
							"fieldInstances": [],
							"__worldX": 1136,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163ce477-21a0-11f1-b642-55290ab08053",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,112],
							"fieldInstances": [],
							"__worldX": 1168,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163ce478-21a0-11f1-b642-395a57f1a347",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,144],
							"fieldInstances": [],
							"__worldX": 1168,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163ce479-21a0-11f1-b642-09c2be75ae1c",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,112],
							"fieldInstances": [],
							"__worldX": 1200,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163ce47a-21a0-11f1-b642-994c67a7867d",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,144],
							"fieldInstances": [],
							"__worldX": 1200,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163ce47b-21a0-11f1-b642-6f82b8d26be5",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,176],
							"fieldInstances": [],
							"__worldX": 1136,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163ce47c-21a0-11f1-b642-019493955892",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,208],
							"fieldInstances": [],
							"__worldX": 1136,
							"__worldY": 16
						},
						{
							"__identifier": "GROUND",
							"__grid": [8,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163ce47e-21a0-11f1-b642-6913b9584e39",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,144],
							"fieldInstances": [],
							"__worldX": 1232,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163ce47f-21a0-11f1-b642-2d8d5dfce8a0",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,176],
							"fieldInstances": [],
							"__worldX": 1168,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [3,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163ce480-21a0-11f1-b642-5ba31b5e45fb",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [112,16],
							"fieldInstances": [],
							"__worldX": 1072,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163d0b80-21a0-11f1-b642-5304b7153d1d",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,16],
							"fieldInstances": [],
							"__worldX": 1104,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163d0b81-21a0-11f1-b642-ef2a148cd09e",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,16],
							"fieldInstances": [],
							"__worldX": 1136,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163d0b82-21a0-11f1-b642-b320bccc05db",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,16],
							"fieldInstances": [],
							"__worldX": 1168,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163d0b83-21a0-11f1-b642-6f94eaaa8029",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,16],
							"fieldInstances": [],
							"__worldX": 1200,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [8,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163d0b84-21a0-11f1-b642-e5b145e8f824",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,16],
							"fieldInstances": [],
							"__worldX": 1232,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [9,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163d0b85-21a0-11f1-b642-e5d4e1632370",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [304,16],
							"fieldInstances": [],
							"__worldX": 1264,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [10,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163d0b86-21a0-11f1-b642-23e7636b383c",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [336,16],
							"fieldInstances": [],
							"__worldX": 1296,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [2,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "163d0b87-21a0-11f1-b642-c9ea36800559",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [80,16],
							"fieldInstances": [],
							"__worldX": 1040,
							"__worldY": -176
						}
					]
				}
			],
			"__neighbours": [ { "levelIid": "a2ecc800-21a0-11f1-b642-4f1e5c2eace0", "dir": "w" }, { "levelIid": "d48cfc30-21a0-11f1-b642-319e02e82050", "dir": "e" } ]
		},
		{
			"identifier": "fifth",
			"iid": "d48cfc30-21a0-11f1-b642-319e02e82050",
			"uid": 91,
			"worldX": 1376,
			"worldY": -192,
			"worldDepth": 0,
			"pxWid": 416,
			"pxHei": 320,
			"__bgColor": "#696A79",
			"bgColor": null,
			"useAutoIdentifier": false,
			"bgRelPath": null,
			"bgPos": null,
			"bgPivotX": 0.5,
			"bgPivotY": 0.5,
			"__smartColor": "#ADADB5",
			"__bgPos": null,
			"externalRelPath": null,
			"fieldInstances": [],
			"layerInstances": [
				{
					"__identifier": "interactions",
					"__type": "Entities",
					"__cWid": 13,
					"__cHei": 10,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "d48cfc31-21a0-11f1-b642-1fdb759466c8",
					"levelId": 91,
					"layerDefUid": 65,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 7174765,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": []
				},
				{
					"__identifier": "entities",
					"__type": "Entities",
					"__cWid": 13,
					"__cHei": 10,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "d48cfc32-21a0-11f1-b642-6b24dcfee9ea",
					"levelId": 91,
					"layerDefUid": 64,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 7422727,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "ZONE",
							"__grid": [15,6],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 384, "y": 64, "w": 16, "h": 16 },
							"__smartColor": "#63C74D",
							"iid": "d48cfc33-21a0-11f1-b642-7fd20bef19af",
							"width": 32,
							"height": 32,
							"defUid": 85,
							"px": [496,208],
							"fieldInstances": [],
							"__worldX": 1872,
							"__worldY": 16
						},
						{
							"__identifier": "ZONE",
							"__grid": [15,5],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 384, "y": 64, "w": 16, "h": 16 },
							"__smartColor": "#63C74D",
							"iid": "d48cfc34-21a0-11f1-b642-59fef803f10f",
							"width": 32,
							"height": 32,
							"defUid": 85,
							"px": [496,176],
							"fieldInstances": [],
							"__worldX": 1872,
							"__worldY": -16
						},
						{
							"__identifier": "HERO",
							"__grid": [6,3],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 0, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#124E89",
							"iid": "d48cfc35-21a0-11f1-b642-8d2df9d5398b",
							"width": 32,
							"height": 32,
							"defUid": 83,
							"px": [208,112],
							"fieldInstances": [],
							"__worldX": 1584,
							"__worldY": -80
						},
						{
							"__identifier": "KING",
							"__grid": [6,0],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 80, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#FF0044",
							"iid": "d48d2340-21a0-11f1-b642-c1f967bcd7e7",
							"width": 32,
							"height": 32,
							"defUid": 87,
							"px": [208,16],
							"fieldInstances": [],
							"__worldX": 1584,
							"__worldY": -176
						},
						{
							"__identifier": "PAWN",
							"__grid": [5,5],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 80, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#FF0044",
							"iid": "d48d2341-21a0-11f1-b642-7b7a9bddfd35",
							"width": 32,
							"height": 32,
							"defUid": 86,
							"px": [176,176],
							"fieldInstances": [],
							"__worldX": 1552,
							"__worldY": -16
						},
						{
							"__identifier": "PAWN",
							"__grid": [7,5],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 80, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#FF0044",
							"iid": "d48d4a50-21a0-11f1-b642-a3167f6e9714",
							"width": 32,
							"height": 32,
							"defUid": 86,
							"px": [240,176],
							"fieldInstances": [],
							"__worldX": 1616,
							"__worldY": -16
						}
					]
				},
				{
					"__identifier": "environment",
					"__type": "Entities",
					"__cWid": 13,
					"__cHei": 10,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "d48d4a51-21a0-11f1-b642-4d022c5e69bb",
					"levelId": 91,
					"layerDefUid": 80,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 3523423,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "GROUND",
							"__grid": [8,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "d48d4a52-21a0-11f1-b642-b5edea91a39b",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,144],
							"fieldInstances": [],
							"__worldX": 1648,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "d48d4a53-21a0-11f1-b642-c390533b25ee",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,144],
							"fieldInstances": [],
							"__worldX": 1616,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "d48d4a54-21a0-11f1-b642-7112c481f0ea",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,176],
							"fieldInstances": [],
							"__worldX": 1616,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "d48d4a55-21a0-11f1-b642-2d2df77f8e22",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,176],
							"fieldInstances": [],
							"__worldX": 1584,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "d48d4a56-21a0-11f1-b642-37b3f05d3a32",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,144],
							"fieldInstances": [],
							"__worldX": 1520,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "d48d4a59-21a0-11f1-b642-053ea655d137",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,112],
							"fieldInstances": [],
							"__worldX": 1552,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "d48d4a5b-21a0-11f1-b642-f573bcd51580",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,112],
							"fieldInstances": [],
							"__worldX": 1584,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "d48d4a5d-21a0-11f1-b642-ed589121ec27",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,112],
							"fieldInstances": [],
							"__worldX": 1616,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "d48d4a5e-21a0-11f1-b642-69c931c91f93",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,144],
							"fieldInstances": [],
							"__worldX": 1552,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "d48d4a5f-21a0-11f1-b642-89dba2d3bf1e",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,176],
							"fieldInstances": [],
							"__worldX": 1552,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [3,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "d48d7162-21a0-11f1-b642-637af677200a",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [112,16],
							"fieldInstances": [],
							"__worldX": 1488,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "d48d7163-21a0-11f1-b642-8fb6315ba85d",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,16],
							"fieldInstances": [],
							"__worldX": 1520,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "d48d7164-21a0-11f1-b642-5348638a9ce1",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,16],
							"fieldInstances": [],
							"__worldX": 1552,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "d48d9870-21a0-11f1-b642-a3943be20577",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,16],
							"fieldInstances": [],
							"__worldX": 1584,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "d48d9871-21a0-11f1-b642-a91f3165a3a8",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,16],
							"fieldInstances": [],
							"__worldX": 1616,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [8,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "d48d9872-21a0-11f1-b642-db48a0eae03c",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,16],
							"fieldInstances": [],
							"__worldX": 1648,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [9,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "d48d9873-21a0-11f1-b642-c956385967e3",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [304,16],
							"fieldInstances": [],
							"__worldX": 1680,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [10,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "d48d9874-21a0-11f1-b642-79c833aefc3e",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [336,16],
							"fieldInstances": [],
							"__worldX": 1712,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [2,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "d48d9875-21a0-11f1-b642-f75bcdb7fecf",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [80,16],
							"fieldInstances": [],
							"__worldX": 1456,
							"__worldY": -176
						}
					]
				}
			],
			"__neighbours": [ { "levelIid": "163c9650-21a0-11f1-b642-65b65ce4be81", "dir": "w" }, { "levelIid": "b9796a90-21a0-11f1-b642-bf81fafe0332", "dir": "e" } ]
		},
		{
			"identifier": "sixth",
			"iid": "b9796a90-21a0-11f1-b642-bf81fafe0332",
			"uid": 92,
			"worldX": 1792,
			"worldY": -192,
			"worldDepth": 0,
			"pxWid": 416,
			"pxHei": 320,
			"__bgColor": "#696A79",
			"bgColor": null,
			"useAutoIdentifier": false,
			"bgRelPath": null,
			"bgPos": null,
			"bgPivotX": 0.5,
			"bgPivotY": 0.5,
			"__smartColor": "#ADADB5",
			"__bgPos": null,
			"externalRelPath": null,
			"fieldInstances": [],
			"layerInstances": [
				{
					"__identifier": "interactions",
					"__type": "Entities",
					"__cWid": 13,
					"__cHei": 10,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "b97991a0-21a0-11f1-b642-c7bbb5c94752",
					"levelId": 92,
					"layerDefUid": 65,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 7174765,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": []
				},
				{
					"__identifier": "entities",
					"__type": "Entities",
					"__cWid": 13,
					"__cHei": 10,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "b97991a1-21a0-11f1-b642-f743ec8df98b",
					"levelId": 92,
					"layerDefUid": 64,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 7422727,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "ZONE",
							"__grid": [15,6],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 384, "y": 64, "w": 16, "h": 16 },
							"__smartColor": "#63C74D",
							"iid": "b97991a2-21a0-11f1-b642-bb009dcd13a4",
							"width": 32,
							"height": 32,
							"defUid": 85,
							"px": [496,208],
							"fieldInstances": [],
							"__worldX": 2288,
							"__worldY": 16
						},
						{
							"__identifier": "ZONE",
							"__grid": [15,5],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 384, "y": 64, "w": 16, "h": 16 },
							"__smartColor": "#63C74D",
							"iid": "b97991a3-21a0-11f1-b642-bf91583d264b",
							"width": 32,
							"height": 32,
							"defUid": 85,
							"px": [496,176],
							"fieldInstances": [],
							"__worldX": 2288,
							"__worldY": -16
						},
						{
							"__identifier": "HERO",
							"__grid": [6,3],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 0, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#124E89",
							"iid": "b97991a4-21a0-11f1-b642-05ff19d3e0e8",
							"width": 32,
							"height": 32,
							"defUid": 83,
							"px": [208,112],
							"fieldInstances": [],
							"__worldX": 2000,
							"__worldY": -80
						},
						{
							"__identifier": "KING",
							"__grid": [6,0],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 80, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#FF0044",
							"iid": "b97991a5-21a0-11f1-b642-9b2590675156",
							"width": 32,
							"height": 32,
							"defUid": 87,
							"px": [208,16],
							"fieldInstances": [],
							"__worldX": 2000,
							"__worldY": -176
						},
						{
							"__identifier": "PAWN",
							"__grid": [5,5],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 80, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#FF0044",
							"iid": "b97991a6-21a0-11f1-b642-cd84840c0906",
							"width": 32,
							"height": 32,
							"defUid": 86,
							"px": [176,176],
							"fieldInstances": [],
							"__worldX": 1968,
							"__worldY": -16
						},
						{
							"__identifier": "PAWN",
							"__grid": [7,5],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 80, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#FF0044",
							"iid": "b97991a7-21a0-11f1-b642-313938349846",
							"width": 32,
							"height": 32,
							"defUid": 86,
							"px": [240,176],
							"fieldInstances": [],
							"__worldX": 2032,
							"__worldY": -16
						},
						{
							"__identifier": "PAWN",
							"__grid": [4,6],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 80, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#FF0044",
							"iid": "dc3ec890-21a0-11f1-b642-6d6334c059ea",
							"width": 32,
							"height": 32,
							"defUid": 86,
							"px": [144,208],
							"fieldInstances": [],
							"__worldX": 1936,
							"__worldY": 16
						},
						{
							"__identifier": "PAWN",
							"__grid": [8,6],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 80, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#FF0044",
							"iid": "dcee6980-21a0-11f1-b642-834e31d52880",
							"width": 32,
							"height": 32,
							"defUid": 86,
							"px": [272,208],
							"fieldInstances": [],
							"__worldX": 2064,
							"__worldY": 16
						}
					]
				},
				{
					"__identifier": "environment",
					"__type": "Entities",
					"__cWid": 13,
					"__cHei": 10,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "b97991a8-21a0-11f1-b642-99eec8704be0",
					"levelId": 92,
					"layerDefUid": 80,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 3523423,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "GROUND",
							"__grid": [8,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b97991a9-21a0-11f1-b642-49bcc1b3b327",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,144],
							"fieldInstances": [],
							"__worldX": 2064,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b979b8b0-21a0-11f1-b642-370c562008a0",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,144],
							"fieldInstances": [],
							"__worldX": 2032,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b979b8b1-21a0-11f1-b642-97df032c9ed2",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,176],
							"fieldInstances": [],
							"__worldX": 2032,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b979b8b2-21a0-11f1-b642-7186ee2c207f",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,176],
							"fieldInstances": [],
							"__worldX": 2000,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b979b8b3-21a0-11f1-b642-7900eb5d2937",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,144],
							"fieldInstances": [],
							"__worldX": 1936,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b979b8b4-21a0-11f1-b642-dd2328b5a07b",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,112],
							"fieldInstances": [],
							"__worldX": 1968,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b979b8b5-21a0-11f1-b642-d15ea3c23a45",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,112],
							"fieldInstances": [],
							"__worldX": 2000,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b979b8b6-21a0-11f1-b642-abf5bacea363",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,112],
							"fieldInstances": [],
							"__worldX": 2032,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b979b8b7-21a0-11f1-b642-d5c539a790d9",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,144],
							"fieldInstances": [],
							"__worldX": 1968,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b979b8b8-21a0-11f1-b642-d55a1648eb16",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,176],
							"fieldInstances": [],
							"__worldX": 1968,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [3,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b979b8b9-21a0-11f1-b642-c95061693243",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [112,16],
							"fieldInstances": [],
							"__worldX": 1904,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b979b8ba-21a0-11f1-b642-f38ca29f9417",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,16],
							"fieldInstances": [],
							"__worldX": 1936,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b979b8bb-21a0-11f1-b642-93f799704e63",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,16],
							"fieldInstances": [],
							"__worldX": 1968,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b979b8bc-21a0-11f1-b642-213ec9527124",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,16],
							"fieldInstances": [],
							"__worldX": 2000,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b979b8bd-21a0-11f1-b642-150801ee3b00",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,16],
							"fieldInstances": [],
							"__worldX": 2032,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [8,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b979b8be-21a0-11f1-b642-2d60a9bc866e",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,16],
							"fieldInstances": [],
							"__worldX": 2064,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [9,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b979dfc0-21a0-11f1-b642-394a2d628349",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [304,16],
							"fieldInstances": [],
							"__worldX": 2096,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [10,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b979dfc1-21a0-11f1-b642-1d1fc2bfa57f",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [336,16],
							"fieldInstances": [],
							"__worldX": 2128,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [2,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b979dfc2-21a0-11f1-b642-6bc169e1b5ad",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [80,16],
							"fieldInstances": [],
							"__worldX": 1872,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "d4599ab0-21a0-11f1-b642-d3243b9a4e66",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,208],
							"fieldInstances": [],
							"__worldX": 1936,
							"__worldY": 16
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "d5176c70-21a0-11f1-b642-9d7366951e6b",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,208],
							"fieldInstances": [],
							"__worldX": 2000,
							"__worldY": 16
						},
						{
							"__identifier": "GROUND",
							"__grid": [8,6],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "d5ba1510-21a0-11f1-b642-d5021472fd3e",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,208],
							"fieldInstances": [],
							"__worldX": 2064,
							"__worldY": 16
						}
					]
				}
			],
			"__neighbours": [ { "levelIid": "d48cfc30-21a0-11f1-b642-319e02e82050", "dir": "w" }, { "levelIid": "a2268a70-21a0-11f1-b642-b7b72cc6908d", "dir": "e" } ]
		},
		{
			"identifier": "seventh",
			"iid": "a2268a70-21a0-11f1-b642-b7b72cc6908d",
			"uid": 93,
			"worldX": 2208,
			"worldY": -192,
			"worldDepth": 0,
			"pxWid": 416,
			"pxHei": 320,
			"__bgColor": "#696A79",
			"bgColor": null,
			"useAutoIdentifier": false,
			"bgRelPath": null,
			"bgPos": null,
			"bgPivotX": 0.5,
			"bgPivotY": 0.5,
			"__smartColor": "#ADADB5",
			"__bgPos": null,
			"externalRelPath": null,
			"fieldInstances": [],
			"layerInstances": [
				{
					"__identifier": "interactions",
					"__type": "Entities",
					"__cWid": 13,
					"__cHei": 10,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "a226ffa0-21a0-11f1-b642-2d10df1f9a8c",
					"levelId": 93,
					"layerDefUid": 65,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 7174765,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": []
				},
				{
					"__identifier": "entities",
					"__type": "Entities",
					"__cWid": 13,
					"__cHei": 10,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "a226ffa1-21a0-11f1-b642-5d60cdbe40a6",
					"levelId": 93,
					"layerDefUid": 64,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 7422727,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "ZONE",
							"__grid": [15,6],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 384, "y": 64, "w": 16, "h": 16 },
							"__smartColor": "#63C74D",
							"iid": "a226ffa2-21a0-11f1-b642-25c2ad4fb2e0",
							"width": 32,
							"height": 32,
							"defUid": 85,
							"px": [496,208],
							"fieldInstances": [],
							"__worldX": 2704,
							"__worldY": 16
						},
						{
							"__identifier": "ZONE",
							"__grid": [15,5],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 384, "y": 64, "w": 16, "h": 16 },
							"__smartColor": "#63C74D",
							"iid": "a22726b0-21a0-11f1-b642-67de1e0effe9",
							"width": 32,
							"height": 32,
							"defUid": 85,
							"px": [496,176],
							"fieldInstances": [],
							"__worldX": 2704,
							"__worldY": -16
						},
						{
							"__identifier": "HERO",
							"__grid": [6,5],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 0, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#124E89",
							"iid": "a22726b1-21a0-11f1-b642-f732a6dbe2eb",
							"width": 32,
							"height": 32,
							"defUid": 83,
							"px": [208,176],
							"fieldInstances": [],
							"__worldX": 2416,
							"__worldY": -16
						},
						{
							"__identifier": "KING",
							"__grid": [6,0],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 80, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#FF0044",
							"iid": "a22726b2-21a0-11f1-b642-a95171e04c67",
							"width": 32,
							"height": 32,
							"defUid": 87,
							"px": [208,16],
							"fieldInstances": [],
							"__worldX": 2416,
							"__worldY": -176
						},
						{
							"__identifier": "PAWN",
							"__grid": [6,3],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 80, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#FF0044",
							"iid": "a22726b3-21a0-11f1-b642-3765199dab9d",
							"width": 32,
							"height": 32,
							"defUid": 86,
							"px": [208,112],
							"fieldInstances": [],
							"__worldX": 2416,
							"__worldY": -80
						},
						{
							"__identifier": "PAWN",
							"__grid": [3,3],
							"__pivot": [0.5,0.5],
							"__tags": ["entity"],
							"__tile": { "tilesetUid": 52, "x": 80, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#FF0044",
							"iid": "a22726b6-21a0-11f1-b642-e32fb24f6497",
							"width": 32,
							"height": 32,
							"defUid": 86,
							"px": [112,112],
							"fieldInstances": [],
							"__worldX": 2320,
							"__worldY": -80
						}
					]
				},
				{
					"__identifier": "environment",
					"__type": "Entities",
					"__cWid": 13,
					"__cHei": 10,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "a22726b7-21a0-11f1-b642-1f9673585a97",
					"levelId": 93,
					"layerDefUid": 80,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 3523423,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "GROUND",
							"__grid": [7,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a22726b9-21a0-11f1-b642-a5bf531ae6f6",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,144],
							"fieldInstances": [],
							"__worldX": 2448,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2274dc0-21a0-11f1-b642-8b5f00b83983",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,176],
							"fieldInstances": [],
							"__worldX": 2416,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2274dc2-21a0-11f1-b642-e9e8a01f4d7a",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,112],
							"fieldInstances": [],
							"__worldX": 2384,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2274dc3-21a0-11f1-b642-cd59cce9dfcb",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,112],
							"fieldInstances": [],
							"__worldX": 2416,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2274dc6-21a0-11f1-b642-ebf722f28a60",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,176],
							"fieldInstances": [],
							"__worldX": 2384,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [3,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2274dc7-21a0-11f1-b642-579d0814071f",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [112,16],
							"fieldInstances": [],
							"__worldX": 2320,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2274dc8-21a0-11f1-b642-cfc53adf1cbb",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,16],
							"fieldInstances": [],
							"__worldX": 2352,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [5,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2274dc9-21a0-11f1-b642-3701f7ca4224",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [176,16],
							"fieldInstances": [],
							"__worldX": 2384,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2274dca-21a0-11f1-b642-e1de5f462321",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,16],
							"fieldInstances": [],
							"__worldX": 2416,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2274dcb-21a0-11f1-b642-45572155a0a8",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,16],
							"fieldInstances": [],
							"__worldX": 2448,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [8,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2274dcc-21a0-11f1-b642-395e60cf66b5",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,16],
							"fieldInstances": [],
							"__worldX": 2480,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [9,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2274dcd-21a0-11f1-b642-6deaa1523454",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [304,16],
							"fieldInstances": [],
							"__worldX": 2512,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [10,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2274dce-21a0-11f1-b642-51f63a071b66",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [336,16],
							"fieldInstances": [],
							"__worldX": 2544,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [2,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "a2274dcf-21a0-11f1-b642-c90db2c674eb",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [80,16],
							"fieldInstances": [],
							"__worldX": 2288,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b4056e50-21a0-11f1-b642-c5e87cc323b0",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,112],
							"fieldInstances": [],
							"__worldX": 2352,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [6,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b51ecd90-21a0-11f1-b642-1f71c1e5668d",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [208,144],
							"fieldInstances": [],
							"__worldX": 2416,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b5768a80-21a0-11f1-b642-194041562ddd",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,176],
							"fieldInstances": [],
							"__worldX": 2352,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [3,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b6baf160-21a0-11f1-b642-d797a69c295a",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [112,112],
							"fieldInstances": [],
							"__worldX": 2320,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [3,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "b713bfc0-21a0-11f1-b642-21bbd76a5f2e",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [112,176],
							"fieldInstances": [],
							"__worldX": 2320,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [8,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "003345d0-21a0-11f1-b642-19d2166f927a",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [272,144],
							"fieldInstances": [],
							"__worldX": 2480,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [4,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "2b858360-21a0-11f1-b642-a345ce3b15c2",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [144,144],
							"fieldInstances": [],
							"__worldX": 2352,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,3],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "2c4ca3f0-21a0-11f1-b642-1b10c0c990ff",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,112],
							"fieldInstances": [],
							"__worldX": 2448,
							"__worldY": -80
						},
						{
							"__identifier": "GROUND",
							"__grid": [7,5],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "2cb047c0-21a0-11f1-b642-db2ccdeeab78",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [240,176],
							"fieldInstances": [],
							"__worldX": 2448,
							"__worldY": -16
						},
						{
							"__identifier": "GROUND",
							"__grid": [1,0],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "338a6e40-21a0-11f1-b642-0354f1cfb445",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [48,16],
							"fieldInstances": [],
							"__worldX": 2256,
							"__worldY": -176
						},
						{
							"__identifier": "GROUND",
							"__grid": [9,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "441c86d0-21a0-11f1-b642-9d7d6be2abc9",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [304,144],
							"fieldInstances": [],
							"__worldX": 2512,
							"__worldY": -48
						},
						{
							"__identifier": "GROUND",
							"__grid": [3,4],
							"__pivot": [0.5,0.5],
							"__tags": ["environment"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 272, "w": 16, "h": 16 },
							"__smartColor": "#68386C",
							"iid": "59364a60-21a0-11f1-b642-4deea85b9ddb",
							"width": 32,
							"height": 32,
							"defUid": 81,
							"px": [112,144],
							"fieldInstances": [],
							"__worldX": 2320,
							"__worldY": -48
						}
					]
				}
			],
			"__neighbours": [{ "levelIid": "b9796a90-21a0-11f1-b642-bf81fafe0332", "dir": "w" }]
		}
	],
	"worlds": [],
	"dummyWorldIid": "d211da70-9b00-11ef-8143-f94a2cc595d5"
});